const formatDate = (date: string): string => {
  const messageDate = new Date(date);
  const currDate = new Date();

  const diffMinutes =
    (currDate.getTime() - messageDate.getTime()) / (1000 * 60);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  return diffMinutes > 10080 //more than a week
    ? `${messageDate.getDate() + " "}${
        monthNames[messageDate.getMonth()] + " "
      }${messageDate.getFullYear()}`
    : diffMinutes > 1440 //day
    ? `${Math.ceil(diffMinutes / 60 / 30)}d`
    : diffMinutes > 60 //hour
    ? `${Math.ceil(diffMinutes / 60)}h`
    : diffMinutes < 60
    ? `${Math.ceil(diffMinutes)}m`
    : `${Math.ceil(diffMinutes * 60)}s`;
};

export default formatDate;
